import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Paper, Modal } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./_style.scss";
import CheckBoxGroupForFakeTableLine from "../../../components/atoms/TkFakeTableLine/components/checkBoxGroupForFakeTableLine";
import { checkList, documentList } from "./parts";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

/**
 * 重要事項確認モーダル画面
 * SCRC030102固有部品
 * @param {boolean} isRegister 同意フラグ
 * @param {boolean} confirmed 親画面のAPIから「重要事項確認日」を受け取ったかどうかのフラグ
 * @return TkImportantMattersModal 重要事項確認モーダル画面
 */
export const TkImportantMattersModal: React.FC<
  TkImportantMattersModalProps
> = ({ isRegister, confirmed }) => {
  const [open, setOpen] = useState(false);
  const [isCheckedAll, setIsCheckedAll] = useState(true);
  const [checkedValue, setCheckedLValue] = useState<string[]>([]);

  const handleScroll = (e: any) => {
    setIsScrolled(
      e.target.scrollHeight - e.target.scrollTop - e.target.offsetHeight <= 0
    );
  };
  const [scroll, setScroll] = useState<any>(null);
  const [numPages, setNumPages] = useState(0); // PDFの総ページ数

  const [isScrolled, setIsScrolled] = useState(false);
  const [isApprovalAll, setIsApprovalAll] = useState(true);

  const [pdfWidth, setPdfWidth] = useState(Math.round(window.innerWidth * 0.8));
  useEffect(() => {
    const handleResize = () => {
      setPdfWidth(Math.round(window.innerWidth * 0.8));
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (confirmed) {
      setIsScrolled(true);
      setIsCheckedAll(true);
      setCheckedLValue(checkList.map((item) => item.label || ""));
    }
  }, [confirmed]);

  useEffect(() => {
    let flg = isScrolled && isCheckedAll;
    setIsApprovalAll(!flg);
    isRegister(flg);
  }, [isScrolled, isCheckedAll, isRegister, confirmed]);

  useEffect(() => {
    let currentDom: any = scroll;

    if (currentDom) {
      currentDom!.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (currentDom) {
        currentDom!.removeEventListener("scroll", handleScroll);
      }
    };
  }, [open, scroll]);

  const onCheck = (e: any) => {
    setCheckedLValue(e);
    setIsCheckedAll(e?.length === checkList.length);
  };

  return (
    <Box>
      <TkButton onClick={() => setOpen(true)}>
        重要事項を確認してください
      </TkButton>

      <Modal
        className="SCRC030102components"
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="importantMattersModal">
          <Box className="documents">
            {documentList.map((item, index) =>
              item.path ? (
                <a
                  href={`${process.env.PUBLIC_URL ?? ""}${item.path}`}
                  download
                  key={`doc-${index}`}
                >
                  <TkButton size="small">{item.label}</TkButton>
                </a>
              ) : (
                <TkButton
                  onClick={() => window.open(item.link)}
                  key={`doc-${index}`}
                >
                  {item.label}
                </TkButton>
              )
            )}
          </Box>
          <Box>
            <Paper
              elevation={0}
              sx={{
                background: "1px",
                overflowY: "scroll",
                overflowX: "hidden",
                height: "500px",
                width: "100%",
                border: 3,
                mb: 1,
              }}
              data-testid="tkModalPaperForTest"
              ref={setScroll}
            >
              <Document
                file={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/RPT021_重要事項確認書.pdf`}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              >
                {Array.from({ length: numPages }, (_, index) => index + 1).map(
                  (pageNumber) => (
                    <Page
                      key={pageNumber}
                      pageNumber={pageNumber}
                      width={pdfWidth}
                    />
                  )
                )}
              </Document>
            </Paper>
          </Box>

          <Box pt={3}>
            上記１～１３の重要事項について、内容を確認してください。
            <br />
            <u>
              ※最後までスクロールして内容を確認していただいた後、画面下部の同意ボタンを押下できるようになります。
            </u>
            <br />
            <br />
            上記１～１３の重要事項をご理解いただけましたら、☐（チェックボックス）に✔を入れていただき、同意ボタンを押下してください。
          </Box>

          <CheckBoxGroupForFakeTableLine
            checkBoxList={checkList}
            onChange={onCheck}
            wantToSetValue={checkedValue}
          />

          <Box className="buttonGroup">
            <TkButton onClick={() => setOpen(false)}>戻る</TkButton>
            <TkButton
              size="small"
              disabled={isApprovalAll}
              onClick={() => setOpen(false)}
            >
              同意します
            </TkButton>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default TkImportantMattersModal;
